export default __webpack_public_path__ + "static/media/prime.ee62e9ee.png";